import { createContext, useState, ReactNode } from 'react';

interface ContractNameContextType {
  contractNumber: string | null;
  setContractNumber: (number: string | null) => void;
}

const DEFAULT_VALUE: ContractNameContextType = {
  contractNumber: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setContractNumber: () => { },
};


export const ContractNameContext = createContext<ContractNameContextType>(DEFAULT_VALUE);
export const ContractNameProvider = ({ children }: { children: ReactNode }) => {
  const [contractNumber, setContractNumber] = useState<string | null>(null);
  return (
    <ContractNameContext.Provider value={{contractNumber, setContractNumber }}>
      {children}
    </ContractNameContext.Provider>
  );
};
